import { Language } from '@/config/languages'
import { routeMatchNames } from '@/router/i18n-router'

import type { RouteRecordRaw } from 'vue-router'

import type { Segments, TranslatedSegment } from '@/router/i18n-router'

export const segments: Segments = {
  workArchive: {
    fr: 'projets',
    en: 'work',
  },
  services: {
    fr: 'nos-services',
    en: 'services',
  },
  careers: {
    fr: 'jobs',
    en: 'careers',
  },
  thankyou: {
    fr: 'merci',
    en: 'thank-you',
  },
  '404Game': {
    fr: 'jeu-video-404',
    en: '404-video-game',
  },
  job: {
    fr: 'job',
    en: 'job',
  },
  work: {
    fr: 'projet',
    en: 'work',
  },
  advergaming: {
    fr: 'advergaming',
    en: 'advergaming',
  },
} satisfies Record<string, TranslatedSegment>

// For translated segments, use `{segmentKey}` in the path
// By default, it will be available through `params.segment`
// If you want another name, use `{segmentKey:paramsName}`
// For example:
//   /{workArchive}/:case/
//     => fr/:segment(projets)/:case/ and en/:segment(work)/:case/
//   /{workArchive:kind}/:case/
//     => fr/:kind(projets)/:case/ and en/:kind(work)/:case/

export const ARTICLE_TEMPLATE_NAME = 'article'

export const definitions: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/views/Homepage.vue'),
    name: 'homepage',
    // meta: {
    //   static: true,                  // No automatic call to API (WP)
    //   endpoint: 'posts',             // Specific endpoint
    //   api: 'http://some-other-api',  // Use different API address
    //   key: 'id',                     // Avoid component re-rendering
    //   root: true,                    // Root route even with languages
    // },
  },
  {
    path: '/{workArchive}/',
    component: () => import('@/views/Works.vue'),
    name: 'works',
    meta: {
      isLocked: false,
    },
  },
  {
    path: '/{services}/',
    component: () => import('@/views/Services.vue'),
    name: 'services',
    meta: {
      isLocked: false,
    },
  },
  {
    path: `/{services}/:subService/`,
    component: () => import('@/views/SubService.vue'),
    name: 'sub-service',
    meta: {
      isLocked: false,
    },
  },
  {
    path: `/{services}/:subService/:subSubService/`,
    component: () => import('@/views/SubService.vue'),
    name: 'sub-sub-service',
    beforeEnter: (to, from) => {
      return !(
        routeMatchNames(from, 'sub-service') &&
        routeMatchNames(to, 'sub-sub-service')
      )
    },
    meta: {
      isLocked: false,
    },
  },
  {
    path: `/{careers}/`,
    component: () => import('@/views/Careers.vue'),
    name: 'careers',
    meta: {
      isLocked: false,
    },
  },
  {
    path: `/{thankyou}/`,
    component: () => import('@/views/pages/Rabbit.vue'),
    name: 'thank-you',
  },
  {
    path: '/{404Game}/',
    component: () => import('@/views/Page.vue'),
    name: '404-game',
  },
  {
    path: '/contact/',
    redirect: to => {
      const lang = to.params.lang as Language
      const formDefaultSegment =
        lang === 'fr' ? 'nouveau-projet' : 'new-project'

      return `/${lang}/contact/${formDefaultSegment}/`
    },
  },
  {
    path: '/journal/',
    component: () => import('@/views/Blog.vue'),
    name: 'blog',
    meta: {
      endpoint: 'pages',
    },
  },
  {
    path: '/article/:case/',
    component: () => import('@/views/SingleBlog.vue'),
    name: 'single-blog',
    meta: {
      endpoint: 'article',
    },
  },
  {
    path: '/job/:case/',
    component: () => import('@/views/SingleJob.vue'),
    name: 'single-job',
    meta: {
      endpoint: 'job',
    },
  },
  {
    path: `/{work}/:case/`,
    component: () => import('@/views/Case.vue'),
    name: 'case',
    props: true,
    meta: {
      endpoint: 'work',
    },
  },
  {
    path: '/registration/',
    component: () => import('@/views/pages/Registration.vue'),
    name: 'registration',
    meta: {
      static: true,
      noChrome: true,
    },
  },
  {
    path: '/:page/:subPage?/',
    component: () => import('@/views/Page.vue'),
    name: 'page',
  },
  {
    path: '/:catchAll(.*)*',
    name: 'catch-all',
    component: () => import('@/views/404.vue'),
  },
]
